import { render, staticRenderFns } from "./EditOrder.vue?vue&type=template&id=cf787bf6&scoped=true&"
import script from "./EditOrder.vue?vue&type=script&lang=js&"
export * from "./EditOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf787bf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf787bf6')) {
      api.createRecord('cf787bf6', component.options)
    } else {
      api.reload('cf787bf6', component.options)
    }
    module.hot.accept("./EditOrder.vue?vue&type=template&id=cf787bf6&scoped=true&", function () {
      api.rerender('cf787bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Orders/EditOrder.vue"
export default component.exports